import type { PriceId } from '@iheartjane/types';

import type { AlgoliaProduct } from '@jane/search/types';
// eslint-disable-next-line no-restricted-imports
import type { MenuProduct } from '@jane/shared/models';
import type { MaterializedMenuProduct } from '@jane/shared/types';

import { maybeParseFloat } from './maybeParseFloat';

export function parsePriceAtPriceId(
  menuProduct: MenuProduct | AlgoliaProduct | MaterializedMenuProduct,
  priceId: PriceId,
  discounted = false
) {
  const pricePrefix = discounted ? 'discounted_price_' : 'price_';
  const price = menuProduct[`${pricePrefix}${priceId}`];
  return maybeParseFloat(price ?? 0) as number;
}

export function lowestPriceForMenuProduct(
  menuProduct: MenuProduct | AlgoliaProduct | MaterializedMenuProduct,
  availableWeights: PriceId[]
) {
  let lowestPriceId = availableWeights[0];
  let lowestMenuProductPrice = parsePriceAtPriceId(
    menuProduct,
    availableWeights[0]
  );

  availableWeights.forEach((priceId) => {
    const pricesAtWeight = [
      parsePriceAtPriceId(menuProduct, priceId),
      parsePriceAtPriceId(menuProduct, priceId, true),
    ].filter(Boolean);
    const lowestPriceAtWeight = Math.min(...pricesAtWeight);

    if (lowestPriceAtWeight < lowestMenuProductPrice) {
      lowestPriceId = priceId;
      lowestMenuProductPrice = lowestPriceAtWeight;
    }
  });

  return lowestPriceId;
}
